import React, { useState, useEffect } from 'react';
import Grid from "@mui/material/Grid";
import theme from "../../theme";
import HomeIcon from '@mui/icons-material/Home';
import ListAltIcon from '@mui/icons-material/ListAlt';

// Responsive drawer imports
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MenuIcon from '@mui/icons-material/Menu';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import HouseIcon from '@mui/icons-material/House';
import CategoryIcon from '@mui/icons-material/Category';
import Toolbar from "@mui/material/Toolbar";
import logo from "../../images/frugal_logo_with_name.png";
import { Link } from 'react-router-dom';
import AccountMenu from "./AccountMenu/AccountMenu";
import {styled} from "@mui/material/styles";
import Tooltip from "@mui/material/Tooltip";
import FreeBreakfastIcon from '@mui/icons-material/FreeBreakfast';
import LunchDiningIcon from '@mui/icons-material/LunchDining';

const drawerWidth = 240;

export default function AppDrawer(props) {
   const PREFIX = 'Priorities';
   const classes = {
      menuButtonParent: `${PREFIX}-menuButtonParent`,
   }
   const Root = styled('div')(({ theme }) => ({
      [`& .${classes.menuButtonParent}`]: {
         display: 'flex',
         justifyContent: 'flex-end',
         width: '100%',
         flex: 1,
      },
   }))


   const { window } = props;
   const [mobileOpen, setMobileOpen] = React.useState(false);
   const [isClosing, setIsClosing] = React.useState(false);

   const handleDrawerClose = () => {
      setIsClosing(true);
      setMobileOpen(false);
   };

   const handleDrawerTransitionEnd = () => {
      setIsClosing(false);
   };

   const handleDrawerToggle = () => {
      if (!isClosing) {
         setMobileOpen(!mobileOpen);
      }
   };


   const drawer = (
      <div>
         <div style={{background: theme.palette.primary.main}}>
            <Toolbar>
               <Grid container justifyContent={"flex-start"}>
                  <img id="nav-logo" src={logo} alt="logo"/>
               </Grid>
            </Toolbar>
         </div>

         <Divider />
         <List>
            <ListItem key={"dashboard"} disablePadding>
               <ListItemButton component={Link} to='/dashboard'>
                  <ListItemIcon>
                     <DashboardIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Dashboard"} />
               </ListItemButton>
            </ListItem>
            <ListItem key={"transactions"} disablePadding>
               <ListItemButton component={Link} to='/transactions'>
                  <ListItemIcon>
                     <ReceiptLongIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Transactions"} />
               </ListItemButton>
            </ListItem>
            <ListItem key={"Budgets"} disablePadding>
               <ListItemButton component={Link} to='/budget-settings'>
                  <ListItemIcon>
                     <AttachMoneyIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Budgets"} />
               </ListItemButton>
            </ListItem>
            <ListItem key={"Categories"} disablePadding>
               <ListItemButton component={Link} to='/categories'>
                  <ListItemIcon>
                     <CategoryIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Categories"} />
               </ListItemButton>
            </ListItem>
            <ListItem key={"Family"} disablePadding>
               <ListItemButton component={Link} to='/account-family'>
                  <ListItemIcon>
                     <HouseIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Family"} />
               </ListItemButton>
            </ListItem>
            <ListItem key={"Contact"} disablePadding>
               <ListItemButton component={Link} to='/contact'>
                  <ListItemIcon>
                     <ContactSupportIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Contact"} />
               </ListItemButton>
            </ListItem>
         </List>
         <Divider />
         <List>
            <ListItem key={"Priorities"} disablePadding>
               <ListItemButton component={Link} to='/priorities'>
                  <ListItemIcon>
                     <ListAltIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Priorities"} />
               </ListItemButton>
            </ListItem>
            <ListItem key={"Mortgage Calculator"} disablePadding>
               <ListItemButton component={Link} to='/mortgage-calculator'>
                  <ListItemIcon>
                     <HomeIcon />
                  </ListItemIcon>
                  <ListItemText primary={"Mortgage Calculator"} />
               </ListItemButton>
            </ListItem>
            <ListItem key={"Meal Wheel"} disablePadding>
               <ListItemButton component={Link} to='/meal-wheel'>
                  <ListItemIcon>
                     <LunchDiningIcon/>
                  </ListItemIcon>
                  <ListItemText primary={"Meal Wheel"} />
               </ListItemButton>
            </ListItem>
         </List>
      </div>
   );

   // Remove this const when copying and pasting into your project.
   const container = window !== undefined ? () => window().document.body : undefined;

   return (
      <Root>
         <Box sx={{ display: 'flex', flexDirection: 'row' }}>
            <CssBaseline />
            <AppBar
               position="fixed"
               sx={{
                  width: { sm: `calc(100% - ${drawerWidth}px)` },
                  ml: { sm: `${drawerWidth}px` },
               }}
            >
               <Toolbar>
                  <IconButton
                     color="inherit"
                     aria-label="open drawer"
                     edge="start"
                     onClick={handleDrawerToggle}
                     sx={{ mr: 2, display: { sm: 'none' } }}
                  >
                     <MenuIcon />
                  </IconButton>
                  {/*Empty div to make account menu on right side.*/}
                  <div style={{ flex: 1 }}></div>
                  <div className={classes.menuButtonParent}>
                     <Link to="https://buymeacoffee.com/deremer" rel="noreferrer">
                        <Tooltip title={"Buy me a coffee"}>
                           <IconButton aria-label="buymeacoffee" color="secondary">
                              <FreeBreakfastIcon/>
                           </IconButton>
                        </Tooltip>
                     </Link>

                     <AccountMenu/>
                  </div>

               </Toolbar>

            </AppBar>

            <Box
               component="nav"
               sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
               aria-label="mailbox folders"
            >

               <Drawer
                  variant="temporary"
                  open={mobileOpen}
                  onTransitionEnd={handleDrawerTransitionEnd}
                  onClose={handleDrawerClose}
                  ModalProps={{
                     keepMounted: true, // Better open performance on mobile.
                  }}
                  sx={{
                     display: { xs: 'block', sm: 'none' },
                     '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                  }}
               >
                  {drawer}
               </Drawer>

               <Drawer
                  variant="permanent"
                  sx={{
                     display: { xs: 'none', sm: 'block' },
                     '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth },
                  }}
                  open
               >
                  {drawer}
               </Drawer>
            </Box>
         </Box>
      </Root>
   );
}






